/* Fashion Finds — storefront client logic */
(function () {
  'use strict';

  const cartCountEls = () => document.querySelectorAll('[data-cart-count]');
  const moneyFormat = (cents) => '$' + (cents / 100).toFixed(2);

  function updateCartCount(count) {
    cartCountEls().forEach(el => el.textContent = count);
  }

  function toast(message, tone) {
    let el = document.querySelector('.ff-toast-live');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ff-toast-live';
      el.style.cssText = 'position:fixed;top:80px;right:22px;background:var(--accent);color:#1a0a2e;padding:10px 16px;border-radius:var(--radius);font-size:13px;font-weight:500;z-index:1000;opacity:0;transition:opacity 0.2s;pointer-events:none;';
      document.body.appendChild(el);
    }
    if (tone === 'mint') {
      el.style.background = 'var(--accent-2)';
      el.style.color = '#04342c';
    } else {
      el.style.background = 'var(--accent)';
      el.style.color = '#1a0a2e';
    }
    el.textContent = message;
    el.style.opacity = '1';
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.style.opacity = '0'; }, 1800);
  }

  async function addToCart(formData) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    return res.json();
  }

  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    updateCartCount(cart.item_count);
    return cart;
  }

  /* Intercept product add-to-cart forms */
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const item = await addToCart(new FormData(form));
      await refreshCart();
      toast('Added: ' + (item.product_title || 'item'));
    } catch (err) {
      toast(err.message || 'Could not add to cart');
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  });

  /* Donation form — set quantity from amount input ($ per quantity-of-1) */
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('[data-donate-form]');
    if (!form) return;
    e.preventDefault();
    const amtEl = form.querySelector('[data-donate-amount]');
    const amount = Math.max(1, Math.round(Number(amtEl.value) || 0));
    amtEl.value = amount;

    const btn = form.querySelector('button[type="submit"]');
    const original = btn ? btn.textContent : 'Donate';
    if (btn) { btn.disabled = true; btn.textContent = 'Processing…'; }
    try {
      await addToCart(new FormData(form));
      await refreshCart();
      toast('Donation $' + amount + ' added', 'mint');
    } catch (err) {
      toast(err.message || 'Donation failed');
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  });

  /* Initial cart-count sync on page load */
  refreshCart().catch(() => {});
})();
